import Echo from 'laravel-echo';

console.log('VITE_REVERB_HOST', import.meta.env.VITE_REVERB_HOST);
console.log('VITE_REVERB_PORT_wsPort', import.meta.env.VITE_REVERB_PORT);
console.log('VITE_REVERB_PORT_wssPort', import.meta.env.VITE_REVERB_PORT);
console.log('VITE_REVERB_SCHEME', import.meta.env.VITE_REVERB_SCHEME);

import Pusher from 'pusher-js';
window.Pusher = Pusher;

window.Echo = new Echo({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
  wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
  enabledTransports: ['ws', 'wss'],
});
// Log connection events
window.Echo.connector.pusher.connection.bind('connected', function () {
  console.log('Connected to Reverb WebSocket server');
});

window.Echo.connector.pusher.connection.bind('disconnected', function () {
  console.log('Disconnected from Reverb WebSocket server');
});

window.Echo.connector.pusher.connection.bind('error', function (error) {
  console.log('Error with Reverb WebSocket connection:', error);
});